export default __webpack_public_path__ + "static/media/offer-management-2.440c87c3.svg";